import ClewStep from "../components/clew-steps/ClewStep.jsx";
import Helmet from "react-helmet";

export default function ClewStepPage() {
  return (
    <>
      <Helmet>
        <title>وظایف من</title>
      </Helmet>
      <ClewStep />
    </>
  );
}
